module.exports = __webpack_public_path__ + "img/prompt_bg.2936fc1d.svg";